import { newColors } from "constants/newColors";
import styled from "styled-components";
import { Check } from "@styled-icons/fa-solid";
import { Star } from "@styled-icons/bootstrap/Star";
import { StarFill } from "@styled-icons/bootstrap/StarFill";

export type StyledCheckBoxProps = {
  checked: boolean;
};

export const StyledLabel = styled.label<StyledCheckBoxProps>`
  display: inline-block;
  width: 20px;
  height: 20px;
  background-color: ${({ checked }) =>
    checked ? newColors.primary : newColors.white};
  border: 1px solid
    ${({ checked }) => (checked ? newColors.primary : "#b2b2b8")};
  box-sizing: border-box;
  position: relative;
  cursor: pointer;

  input[type="checkbox"] {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    white-space: nowrap;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
  }
`;

export const StyledCheck = styled(Check)<StyledCheckBoxProps>`
  color: ${({ checked }) => (checked ? newColors.white : newColors.border)};
  width: 70%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const StyledStar = styled(Star)<StyledCheckBoxProps>`
  color: ${newColors.primary};
  width: 70%;
`;

export const StyledStarFill = styled(StarFill)<StyledCheckBoxProps>`
  color: ${newColors.primary};
  width: 70%;
`;
